import QuestionCard from './QuestionCard';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import { utc } from 'moment';
import PulseLoader from "react-spinners/PulseLoader";
import InfiniteScroll from 'react-infinite-scroller';

import {
  QN_PAGE_LOADED,
  QN_PAGE_UPDATE,
  QN_PAGE_UNLOADED
} from '../constants/actionTypes';

//How many questions in a page
const page_size = 10;

//State here means store
const mapStateToProps = state => ({
  ...state.articleList,
  currentUser: state.common.currentUser,
  profile: state.profile
});

const mapDispatchToProps = dispatch => ({
  onLoad: payload => dispatch({ type: QN_PAGE_LOADED, payload }),
  onUpdate: payload => dispatch({ type: QN_PAGE_UPDATE, payload }),
  onUnload: () => dispatch({ type: QN_PAGE_UNLOADED })
});

class QuestionList extends React.Component {
  componentWillMount() {
    const timestamp = utc().format('YYYY-MM-DD HH:mm:ss.SSS');
    this.setState({ timestamp: timestamp });
    this.props.onLoad(Promise.all([
      agent.Articles.byAuthor({
        author: this.props.username,
        filter: this.props.filter,
        page: 0,
        timestamp,
        haveAnswer: 'N'
      })
    ]));
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
    };
  }

  fetchMoreData = () => {
    this.props.onUpdate(Promise.all([
      agent.Articles.byAuthor({
        author: this.props.username,
        filter: this.props.filter,
        page: this.state.currentPage,
        timestamp: this.state.timestamp,
        haveAnswer: 'N'
      })
    ]));
    //This mutates the state and is not pure/ideal but works in our use case (esp when switching tabs)
    //Using setState launches too many requests on fetchMoreData call and is a pain-in-the-ass
    //This method also ensures the loader can be seen
    if ((this.state.currentPage) * page_size < (this.props.profile.questionCount - this.props.profile.responseCount)) {
      // this.setState((prevState) => ({ currentPage: prevState.currentPage + 1 }));
      this.state.currentPage += 1;
    }
  }

  render() {
    //Promise not done rendering
    if (!this.props.articles) {
      return (
        //div centers the loading element in middle of the screen
        <div style={{ textAlign: "center", position: "sticky", top: "50%" }}>
          <PulseLoader
            size={15}
            margin={5}
            color={"#494CA2"} />
        </div>
      );
    } else {
      return (
        <div className="infinite-scroll">
          <InfiniteScroll
            pageStart={0}
            loadMore={this.fetchMoreData}
            hasMore={this.state.currentPage * page_size < (this.props.profile.questionCount - this.props.profile.responseCount)}
            loader={<div className="loader" key={0} style={{ textAlign: "center" }}>
              <PulseLoader
                size={15}
                margin={5}
                color={"#494CA2"} />
            </div>}
            useWindow={false}
            getScrollParent={() => document.getElementsByClassName('container-background')[0]}
          >
            {this.props.articles.map(article => {
              return (
                <QuestionCard handleBlackout={this.props.handleBlackout} blackout={this.props.blackout} article={article} key={article.id} handleLogin={this.props.handleLogin} currentUser={this.props.currentUser} />
              );
            })}

          </InfiniteScroll>
        </div>
      );
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionList)




// WEBPACK FOOTER //
// ./src/components/QuestionList.js